import { alpha } from '@mui/material';
const useDocumentPreviewStyles = () => {
    return {
        root: {
            width: '100%',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            borderRadius: '14px',
            background: (theme) => theme.palette.common.grey8,
            padding: (theme) => theme.spacing(1.5),
            minHeight: '120px'
        },
        label: {
            fontWeight: 500,
            color: 'text.primary',
            mb: 0.5
        },
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        textContainer: {
            display: 'flex',
            gap: 0.5
        }
    };
};
export default useDocumentPreviewStyles;
